export default "__VITE_ASSET__DUn$hYTi__"